import { axios } from '@Root/API'

export const remove = (studyProgrammeId, fundingBodyId) => {
	return axios.delete(`course-session/${studyProgrammeId}/funding-body/${fundingBodyId}`)
}
